angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "BOOKING_MESSAGE": {
    "HEADING": {
      "BOOK": "Booking request from {name}",
      "BOOK_SENDER": "You have requested to book {name} in {location}",
      "ACCEPT": "You have requested to book {name} in {location}",
      "ACCEPT_SENDER": "Booking request from {name}",
      "CANCEL": "{name} has cancelled this booking request",
      "CANCEL_SENDER": "You have cancelled this booking request",
      "DECLINE": "Sorry, {name} is not available for this booking",
      "DECLINE_SENDER": "You are not available",
      "AUTODECLINE": "Not available",
      "AUTODECLINE_SENDER": "Booking request was cancelled",
      "PAY": "Upfront payment complete",
      "PAY_SENDER": "Upfront payment complete",
      "EXPIRE": "Booking request expired",
      "EXPIRE_SENDER": "Booking request expired",
      "REVIEW": "Please leave a review",
      "REVIEW_SENDER": "Please leave a review",
      "REVIEW_LEFT": "Reviewed",
      "REVIEW_LEFT_SENDER": "Reviewed",
      "OFFER": "{name} wants to show you around in {location}",
      "OFFER_SENDER": "Your Showaround offer in {location}",
      "OFFER_ACCEPT": "Your Showaround offer in {location}",
      "OFFER_ACCEPT_SENDER": "{name} wants to show you around in {location}",
      "OFFER_DECLINE": "Offer was not accepted",
      "OFFER_DECLINE_SENDER": "Offer was not accepted",
    },
    "FOOTER": {
      "BOOK": "Respond to this booking request",
      "BOOK_SENDER": "Awaiting response from {name}",
      "ACCEPT": "Discuss and make an upfront payment.",
      "ACCEPT_SENDER": "You have accepted this booking request",
      "CANCEL": "Booking request cancelled",
      "CANCEL_SENDER": "Booking request cancelled",
      "DECLINE": "Not available",
      "DECLINE_SENDER": "Not available",
      "PAY": "Upfront payment complete",
      "PAY_SENDER": "Upfront payment complete",
      "EXPIRE": "Booking request expired",
      "EXPIRE_SENDER": "Booking request expired"
    },
    "DECLINE": {
      "FINAL": "Sorry, I’m not available for this booking.",
      "MODIFY": "Some booking details don’t fit my schedule.<br>I’d be happy to offer alternative dates, times or durations."
    },
    "LABEL": {
      "MEETING_TIME": "Preferred meeting time",
      "NUMBER_OF_PEOPLE": "Number of people"
    },
    "BUTTON": {
      "ACCEPT": "Let's discuss",
      "DECLINE": "<span class=\"u-hidden-m-inline\">Sorry, I'm</span> not available",
      "PAY": "Pay",
      "CANCEL": "Cancel",
      "REVIEW": "Leave a review",
      "MODIFY": "Modify your booking"
    },
    "DURATION": "for {hours} {hours, plural, one{hour} other{hours}}",
    "RESPONSE_FROM": "Response from {name}",
    "CONTACTS": {
      "GUIDE": "Local host contact info",
      "GUEST": "Guest contact info"
    }
  }
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/nls/booking_message.json
// module id = 86
// module chunks = 24